import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { PromptModal } from '../../components/Modal';
import { claimReplies } from '../../../../ducks/question';
import { isMobile, openLogin } from '../../../../mobile/helpers';
import { navigate } from '../../../../helpers';
import withUser from '../../../../components/withUser';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  awaitingClaim: PropTypes.arrayOf(PropTypes.shape({
    question_id: PropTypes.string.isRequired,
    answer_id: PropTypes.string.isRequired,
  })),
};

class ClaimPrompt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideForNow: false,
    };
  }

  componentDidMount() {
    const { user, awaitingClaim, dispatch } = this.props;
    if (user && awaitingClaim?.length > 0) {
      dispatch(claimReplies(awaitingClaim));
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, awaitingClaim, user } = this.props;
    if (user && !prevProps.user && awaitingClaim?.length > 0) {
      dispatch(claimReplies(awaitingClaim));
    }
  }

  render() {
    const {
      awaitingClaim,
      history,
      user,
    } = this.props;

    const { hideForNow } = this.state;

    return (
      <PromptModal
        isOpen={!hideForNow && (!user && awaitingClaim?.length > 0)}
        onRequestClose={() => this.setState({ hideForNow: true })}
        title="Log in to save your answer"
        message="We got your answer, but you need to log in to or register a DreamHack account to compete in the leaderboards."
        action={{
          onClick: isMobile()
            ? () => openLogin()
            : () => navigate(history, `/login/${btoa(history.location.pathname)}`),
          text: 'Log in or register',
        }}
        buttonText="Nah, maybe later"
      />
    );
  }
}

ClaimPrompt.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    awaitingClaim: state.getIn(['question', 'awaitingClaim']),
  };
}

export default withUser(connect(mapStateToProps)(ClaimPrompt));
